import React from 'react';

import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import { MiniIklan } from '.';


const ListItemIklan =React.memo((props)=>{
  const {
    ads,
    onClick,
  }=props

  const handleAdsClick=React.useCallback(()=>{
    if(!!onClick) onClick(ads)
  },[ads,onClick])

  return (
    <>
      <ListItem
        button
        onClick={handleAdsClick}
        //divider
        style={{
          height:"100px",
          overflowY:"hidden",
          padding:"0px 8px",
        }}
        disableGutters
      >
        <ListItemIcon>
          <MiniIklan
            liveAds={ads}
            light={false}
            showPrice={false}
          />
        </ListItemIcon>
        
        <ListItemText
          primary={ads?.name}
          secondary={<span>{ads?.description}<br/>
            <sup style={{color:"black",fontWeight:"bold"}}>Rp </sup>
            <span style={{color:"black",fontWeight:"bold",fontSize:"24px"}}>{" "+ads?.purchasePrice?.toLocaleString("ID-id")}</span>
            <span style={{color:"black",position:"absolute",bottom:"16px",right:"8px"}}>{ads?.sellerName}</span>
          </span>}
          secondaryTypographyProps={{style:{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}}
          primaryTypographyProps={{style:{fontWeight:"bold"}}}
          style={{
            paddingLeft:"16px",
          }}
        />
      </ListItem>
      <Divider style={{margin:"0px 8px"}}/>
    </>
  )
})

export default ListItemIklan